import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('login', defineAsyncComponent(() => import(/* webpackChunkName: "login" */ './Index.vue')))
}
